import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomerStatData } from '../../shared/types';
import { MobileDetectionMixin } from '../../shared/mixins/mobile-detection.mixin';

@Component({
  selector: 'app-customer-stats-card',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './customer-stats-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./customer-stats-card.component.scss'],
})
export class CustomerStatsCardComponent extends MobileDetectionMixin {
  @Input() data!: CustomerStatData;
}
